import React from 'react';
import SearchForm from './components/SearchForm';

function Search() {
return (
<div>

<h2>Search by Strain</h2>
<SearchForm></SearchForm>

{

}
</div>
);
}

export default Search;
